import { axiosInstance as axios, handleAxiosErrors } from '../../_utils';
import config from '../../store/_config';
import { convertUserDetailedInformationToAReadableFormat } from '../../selectors/converterSelector';
import { toggleLoading, setUserInfo } from '../userActions';

export const axiousRequestCartRuleListing = () => {
    let { url, query } = config.user.cartRule.listing;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query,
        },
    });
};

export const requestCartRule = () => {
    return (dispatch) => {
        dispatch(toggleLoading('cartRuleList', true));
        return axiousRequestCartRuleListing()
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    {
                        CartRule:
                            response.data.data
                                .readCartRules,
                    }
                );
                dispatch(setUserInfo(userInfo));
                dispatch(toggleLoading('cartRuleList', false));
            })
            .catch((error) => {
                handleAxiosErrors(error);
                dispatch(toggleLoading('cartRuleList', false));
            });
    };
};

const axiosCreateCartRule = (formData) => {
    const { url, query } = config.user.createCartRule;

    const data = {
        operationName: 'createCartRule',
        query: query,
        variables: {
            Input: formData,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};

/**
 * Create a new cartRule
 *
 * @param formData
 * @param callback
 */
export const createCartRule = (formData, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosCreateCartRule(formData)
            .then((response) => {
                dispatch(requestCartRule());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

const axiosDeleteCartRule = (ID) => {
    let { url, query } = config.user.deleteCartRule;

    let data = {
        query: query,
        variables: {
            IDs: [Number(ID)],
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};

export const deleteCartRule = (id, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosDeleteCartRule(id)
            .then((response) => {
                dispatch(requestCartRule());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

const axiosEditCartRule = (formData) => {
    const { url, query } = config.user.editCartRule;

    let data = {
        query: query,
        variables: {
            Input: formData,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};

/**
 * Edit the selected cartRule
 *
 * @param id
 * @param callback
 */
export const editCartRule = (formData, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosEditCartRule(formData)
            .then((response) => {
                dispatch(requestCartRule());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};
